import { Grid, Typography } from '@mui/material';
import React from 'react';
import { APPOINTMENTS } from '../../shared/Strings';
import { DrawerBoxComponent } from '../DrawerBoxComponent/DrawerBoxComponent';

export const AppointmentDateTimeSummary = ({ dateTime }) => {
  return (
    <DrawerBoxComponent>
      <Grid container spacing={2} alignItems="center">
        <Grid item>
          <Typography variant="navSelected">
            {APPOINTMENTS.DATE_AND_TIME}
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="h5">{dateTime}</Typography>
        </Grid>
      </Grid>
    </DrawerBoxComponent>
  );
};
